import React from "react";
import { Flex, Span } from "@catchoftheday/cg-components";
import { formatPrice } from "@catchoftheday/utilities";
import { ONEPASS_MONTHLY_PRICE, ONEPASS_YEARLY_PRICE } from "../../../consts";
const Price = (props) => (<Span lineHeight="normal" fontSize={{ xs: "lg", md: "2xl" }} fontWeight="bold" {...props}/>);
const Interval = (props) => (<Span fontSize={{ xs: "sm", md: "lg" }} fontWeight="bold" {...props}/>);
export const Pricing = () => {
    return (<Flex mb={3} alignItems="flex-end">
      <Price>{formatPrice(ONEPASS_MONTHLY_PRICE, false)}</Price>
      <Interval>/month</Interval>
      <Span mx={1} fontSize={{ xs: "sm", md: "lg" }} fontWeight="normal">
        or
      </Span>
      <Price>{formatPrice(ONEPASS_YEARLY_PRICE, false)}</Price>
      <Interval>/year</Interval>
    </Flex>);
};
